import React from 'react'
import ProductPage from '../../component/ProductSales/ProductSalesPage/ProductPage'
import FloatingContactUs from '../../component/floting_contact/FloatingContactUs'
import { Helmet } from "react-helmet-async";
const ProductSalePage = () => {
  return (
    <>
      {/* ✅ Meta Tags for SEO */}
   <Helmet>
  <title>PLM Product Sales & Solutions</title>
  <meta
    name="description"
    content="Explore and purchase advanced PLM products and solutions in Pune, India. Nextech PLM delivers reliable products for efficient business operations."
  />
  <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
</Helmet>

      
    <div>
      <ProductPage/>
      <FloatingContactUs />
    </div>
    </>
  )
}

export default ProductSalePage